import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Alert,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const FinancialSource = () => {
  const [detailText, setDetailText] = useState('');
  const [documents, setDocuments] = useState([{ konu: '', belge: '' }]);

  const handleFileSelect = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const newDocuments = [...documents];
      newDocuments[index].belge = file.name;
      setDocuments(newDocuments);
    }
  };

  const handleAddDocument = () => {
    setDocuments([...documents, { konu: '', belge: '' }]);
  };

  const handleKonuChange = (event, index) => {
    const newDocuments = [...documents];
    newDocuments[index].konu = event.target.value;
    setDocuments(newDocuments);
  };

  return (
    <Container maxWidth="xl">
      {/* Başlık */}
      <Paper 
        sx={{ 
          p: 2, 
          mt: 3, 
          mb: 3, 
          bgcolor: '#f5f5f5'
        }}
      >
        <Typography variant="h6">
          Fon Kaynakları ve Finansman Yapısı
        </Typography>
      </Paper>

      {/* Uyarı Kutusu */}
      <Alert 
        severity="info" 
        sx={{ 
          mb: 4,
          bgcolor: '#fff9c4',
          '& .MuiAlert-message': {
            color: 'text.secondary'
          }
        }}
      >
        Girişim şirketinin kısa ve uzun vadeli fon kaynakları, fon kaynaklarının kullanımına ilişkin herhangi bir sınırlama olup olmadığı, borçlanma ihtiyacı, borç yapısı ve nakit akışı hakkında bilgi vererek, mevcut yükümlülüklerinizi karşılamak için yeterli işletme sermayesinin bulunup bulunmadığı hakkında bilgiler veriniz.
      </Alert>

      {/* Detaylı Bilgi Metin Alanı */}
      <TextField
        fullWidth
        multiline
        rows={6}
        placeholder="Detaylı Bilgi Giriniz."
        value={detailText}
        onChange={(e) => setDetailText(e.target.value)}
        sx={{ mb: 4 }}
        InputProps={{
          endAdornment: (
            <Box sx={{ position: 'absolute', right: 8, bottom: 8, color: 'text.secondary' }}>
              {detailText.length} / 3000
            </Box>
          ),
        }}
      />

      {/* Belgeler Bölümü */}
      <Paper 
        sx={{ 
          p: 2, 
          mb: 3, 
          bgcolor: '#f5f5f5'
        }}
      >
        <Typography variant="h6">
          Eklemek İstediğiniz Diğer Belgeler
        </Typography>
      </Paper>

      {/* Belge Ekleme Butonu */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography>Diğer Belge</Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            size="small"
            onClick={handleAddDocument}
          >
            Yeni Ekle
          </Button>
        </Box>
      </Paper>

      {/* Belgeler Tablosu */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Konu</TableCell>
              <TableCell>Belge</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.map((doc, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Konu giriniz"
                    value={doc.konu}
                    onChange={(e) => handleKonuChange(e, index)}
                  />
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<AttachFileIcon />}
                    size="small"
                  >
                    Dosya Seç
                    <input
                      type="file"
                      hidden
                      onChange={(e) => handleFileSelect(e, index)}
                    />
                  </Button>
                  {doc.belge && <Typography variant="body2">{doc.belge}</Typography>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default FinancialSource;